var React = require('react');

function Exclamation (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.45108 0C3.7912 0 0 3.7912 0 8.45108C0 13.111 3.7912 16.9022 8.45108 16.9022C13.111 16.9022 16.9022 13.111 16.9022 8.45108C16.9022 3.7912 13.111 0 8.45108 0ZM8.45111 12.9981C8.00233 12.9981 7.63851 12.6342 7.63851 12.1855C7.63851 11.7367 8.00233 11.3729 8.45111 11.3729C8.8999 11.3729 9.26372 11.7367 9.26372 12.1855C9.26372 12.6342 8.8999 12.9981 8.45111 12.9981ZM9.3335 4.82528L9.10029 9.78215C9.10029 10.1412 8.80923 10.4322 8.4502 10.4322C8.09117 10.4322 7.80012 10.1412 7.80012 9.78215L7.5669 4.82772V4.82569C7.55298 4.50137 7.71807 4.19555 7.99684 4.02924C8.27562 3.86293 8.62316 3.86293 8.90193 4.02924C9.18071 4.19555 9.3458 4.50137 9.33188 4.82569L9.3335 4.82528Z","fill":"#E60017"}));
}

Exclamation.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Exclamation;

Exclamation.default = Exclamation;
